<template>
  <div id="mask" @click="onshut">
    <div
      class="messagebox"
      @click="hideindu($event)"
      :style="'width:' + width + ';height:' + height"
    >
      <div class="title">
        <div style="position: relative">
          <h4>选择项目经理</h4>
          <el-input
            prefix-icon="el-icon-search"
            type="text"
            class="search_input"
            v-model.trim="search_cont"
            @input="searchInput_cont"
          />
          <!-- <div class="searchBox" v-if="searchList">
            <div
              v-for="item in searchList"
              @click="select_searchResult(item)"
            >{{item.name}}{{item.mobile ? '('+item.mobile+')' : ""}}</div>
          </div> -->
        </div>
        <div class="closeMenb" @click="onshut"></div>
      </div>
      <div class="content" style="min-height: 320px">
        <div class="tree" style="overflow: auto">
          <el-tree
            :data="data"
            :props="propsa"
            @node-click="selectDepartment"
          ></el-tree>
        </div>
        <div class="ctable" style="overflow: auto">
          <div class="rowBox">
            <div class="rowContent" style="font-weight: bold">姓名</div>
            <!-- <div class="rowContent" style="font-weight:bold;">部门</div> -->
            <div class="rowContent rowContent2"></div>
          </div>
          <div
            class="rowBox"
            v-for="(item, index) in staffList"
            :key="'staffItem' + index"
            @click="selectStaff(item.userId, item)"
          >
            <div class="rowContent">
              {{ item.name }}{{ item.mobile ? "(" + item.mobile + ")" : "" }}
            </div>
            <div class="rowContent">{{ item.orgName }}</div>
            <div
              class="rowContent rowContent2"
              style="color: #67c23a; fonts-size: 22px; font-weight: bolder"
            >
              <i class="el-icon-check" v-if="selectIndex == item.userId"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <div>
          <span
            class="selectStaff"
            v-for="(item2, index2) in selectlist"
            v-if="selectlist"
          >
            {{ item2.name }}{{ item2.mobile ? "(" + item2.mobile + ")" : "" }}
            <i class="el-icon-close" @click="deleteStaff(index2)"></i>
          </span>
        </div>
        <div class="selectNum">
          <div v-if="selectlist">
            已选择
            <span>{{ selectlist.length }}</span
            >人
          </div>
          <div>
            <button @click="onshut">取消</button>
            <button class="subbtn" @click="onsub">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "../axios.js";
export default {
  data() {
    return {
      data: [],
      phoneStr: "", //所有管理员手机号
      staffList: [],
      selectIndex: "", //单选被选中行
      selectlist: [], //选中集合
      search_cont: "", //模糊搜索内容
      searchList: "", //模糊搜索结果
      propsa: {
        value: "id",
        children: "childs",
        label: "name",
      },
    };
  },
  props: {
    showDefaultData: {
      type: Object,
      default: {},
    },
    width: {
      default: "850px",
    },
    height: {
      default: "670px",
    },
    defaultProps: {
      type: Object,
      default() {
        return {};
      },
    },

    type: {
      default() {
        return "";
      },
    },
  },
  
  mounted() {
    // this.selectlist = this.defaultProps
   
    if (this.showDefaultData.manger) {  
      this.selectlist = [
        {
          name: this.showDefaultData.manger,
          userId: this.showDefaultData.mangerId,
          mobile: this.showDefaultData.mobile,
          orgName: this.showDefaultData.orgName,
        },
      ];
      this.staffList = [
        {
          name: this.showDefaultData.manger,
          userId: this.showDefaultData.mangerId,
          mobile: this.showDefaultData.mobile,
          orgName: this.showDefaultData.orgName,
        },
      ];
      this.selectIndex = this.showDefaultData.mangerId;
    } else if (this.defaultProps.mangerLister) {
      this.selectlist = this.defaultProps.mangerLister;
      this.staffList = this.defaultProps.mangerLister;
      this.defaultProps.mangerLister.forEach((v, k) => {
        this.selectIndex = v.userId;
      });
    } else if (this.defaultProps.partner) {
      this.selectlist = this.defaultProps.partner;
      this.staffList = this.defaultProps.partner;
      this.defaultProps.partner.forEach((v, k) => {
        this.selectIndex = v.userId;
      });
    }
  },
  created() {
    if (this.type == "mangerLister") {
      this.loadTree();
    } else if (this.type == "partner") {
      this.loadTree();
    }
    // this.loadSysUserlist();
  },
  methods: {
    loadTree() {
      this.$axios
        .get("common/org/tree")
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //获取账号权限列表
    loadSysUserlist() {
      this.$axios.get("/users/loadUsers").then((res) => {
        let phoneStr = "";
        for (var i = 0; i < res.data.length; i++) {
          phoneStr += res.data[i].mobile + ",";
        }
        this.phoneStr = phoneStr.substring(0, phoneStr.length - 1);
        this.loadStaff();
      });
    },
    //选中部门
    selectDepartment(val) {
      this.loadStaff(val.id);
    },
    //获取员工
    loadStaff(orgId, content) {
      let id = orgId ? orgId : "";
      let search_content = content ? content : "";
      if (search_content) {
        id = 0;
      } else if (!search_content && id == "") {
        id = 0;
      }
      this.$axios
        .get("/common/user/list?orgId=" + id + "&name=" + search_content)
        .then((res) => {
          if (res.data.status == 1) {
            this.staffList = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    selectStaff(index, row) {
      this.selectIndex = index;
      this.selectlist = [];
      this.selectlist.push(row);
    },
    hideindu(e) {
      e.stopPropagation();
    },
    //确认选中事件
    onsub() {
      if (this.selectlist.length > 0) {
        var obj = {};
          
        obj.mangerList = this.selectlist;
        obj.partner = this.selectlist;
    
        this.$emit("sub", obj);
        // this.$emit("sub", JSON.stringify(this.selectlist));
        this.$parent.maskshow = false;
      } else {
        this.$message.error("请选择人员");
      }
    },
    // 弹框取消事件
    onshut() {
				this.$emit('shut',this.selectlist);
      
      this.$parent.maskshow = false;
    },
    //模糊搜索
    searchInput_cont(val) {
      this.loadStaff("", this.search_cont);
    },
    select_searchResult(content) {
      this.search_cont = content.name + "(" + content.mobile + ")";
      this.selectlist.push(content);
      this.searchList = [];
    },
    deleteStaff(index) {
      this.selectIndex = -1;
      this.selectlist.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="less">
#mask {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.messagebox {
  background-color: #fff;
  box-sizing: border-box;
  max-height: 80%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  .title {
    width: 100%;
    min-height: 66px;
    border-bottom: 1px solid #e9eff4;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    h4 {
      font-size: 18px;
      font-weight: bold;
      display: inline-block;
      padding-right: 16px;
    }
    .search_input {
      width: 360px;
      height: 32px;
      border: 1px solid #e2e5ed;
      border-radius: 4px;
    }
    .searchBox {
      width: 360px;
      background: #fff;
      border: 1px solid #e2e5ed;
      border-radius: 4px;
      position: absolute;
      top: 34px;
      left: 109px;
      z-index: 100;
      div {
        padding: 5px 10px;
        cursor: pointer;
      }
    }
    .closeMenb {
      width: 12px;
      height: 12px;
      background-image: url(../../assets/img/cha.png);
      background-position: left top;
      background-repeat: no-repeat;
      background-size: 12px;
      cursor: pointer;
    }
    .closeMenb:hover {
      background-image: url(../../assets/img/cha_check.png);
    }
  }
  .content {
    width: 100%;
    // height: 100%;
    // overflow: auto;
    display: flex;
    .tree {
      width: 35%;
      height: 100%;
      border-right: 1px solid #e9eff4;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      // margin-left: 23px;
      background: #f7f8fc;
      padding: 30px 0 0 30px;
      .c_name:hover {
        background-color: #f2f5f8;
      }
      .c_checked {
        background-color: #f2f5f8;
        font-weight: bold;
      }
      .c_checked:after {
        content: "";
        display: block;
        width: 4px;
        height: 42px;
        background-color: #6669e3;
        position: absolute;
        right: 0;
        top: 0;
      }
      .c_name {
        width: 100%;
        height: 42px;
        line-height: 42px;
        // background-color: #f2f5f8;
        font-size: 14px;
        display: flex;
        position: relative;
        padding-left: 28px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .c_tree {
        width: 100%;
        box-sizing: border-box;
      }
    }
    .ctable {
      width: 65%;
      /*overflow: auto;*/
      padding: 0 17px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .name {
        margin-top: 20px;
        font-size: 14px;
        font-weight: bold;
        margin-right: 14px;
        min-height: 21px;
      }
      .search {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding: 19px 0;
        min-height: 34px;
        span {
          margin-right: 15px;
        }
        button {
          margin-left: 17px;
        }
      }
      .checkedall {
        padding-bottom: 12px;
        padding-left: 14px;
      }
      .table {
        width: 100%;
        height: 100%;
        overflow: auto;
        .load {
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
  .btns {
    width: 100%;
    // min-height: 62px;
    // display: flex;
    // justify-content: flex-end;
    // align-items: center;
    background-color: #fff;
    padding: 10px 25px 0 25px;
    box-sizing: border-box;
    border-top: 1px solid #f0f2f7;
    div {
      font-size: 14px;
      font-weight: bold;
      span {
        color: #6669e3;
      }
    }
    button {
      min-width: 82px;
      height: 32px;
      color: #6669e3;
      border: 1px solid #6669e3;
      margin-left: 15px;
      border-radius: 6px;
      background-color: #f2f5f8;
      font-size: 14px;
      cursor: pointer;
      padding: 0 20px;
    }
    button:first-child {
      margin-left: 0;
    }
    .subbtn {
      background-color: #6669e3;
      color: #ffffff;
    }
  }
  .block {
    padding: 4px 5px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 20px;
  }
  .redbg {
    background-color: #ff6752;
  }
  .greenbg {
    background-color: #3bc798;
  }
}
.el-tree {
  background: #f7f8fc;
}
.rowBox {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #f0f2f7;
  padding: 6px 0;
}
.rowContent {
  width: 40%;
  color: #535b6a;
  font-size: 12px;
  padding-left: 20px;
  line-height: 33px;
}
.rowContent2 {
  width: 20%;
  font-size: 22px;
}
.selectStaff {
  padding: 4px 6px;
  color: #535b6a !important;
  font-size: 12px;
  background: #eceef4;
  margin-right: 8px;
  border-radius: 2px;
  display: inline-block;
}
.closeBtn {
  width: 12px;
  height: 12px;
  background-image: url(../../assets/img/cha.png);
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 12px;
  cursor: pointer;
}
.selectNum {
  margin: 10px 0 20px 0;
  color: #535b6a;
  display: flex;
  justify-content: space-between;
}
</style>
